import React from 'react';

const ArrowLeft = () => (
    <svg width="40px" height="40px" viewBox="0 0 40 40" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="icons/arrow--left" fill="#1BC77E">
                <path
                    d="M20.8342178,25.1782836 L25.9497479,19.8201031 L27.8531168,21.6206226 L19.5259894,30.4802165 L11.1864501,21.6213703 L13.0884033,19.8193554 L18.2141636,25.1798108 L18.2141636,9.51978348 L20.8342178,9.51978348 L20.8342178,25.1782836 Z"
                    id="arrow"
                    transform="translate(19.519783, 20.000000) rotate(90.000000) translate(-19.519783, -20.000000) "
                ></path>
            </g>
        </g>
    </svg>
);

export default ArrowLeft;
